<!-- 附带料 -->
<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/mouldProduct/page"
			getKey="rows" :columns="columns">
			<template #top>
				<div class="mouldEquipment mouldProduct">
					<el-descriptions :colon="false">
						<el-descriptions-item :label="$t('mujubianhao')" class="noborder">
							{{$attrs.mouldEquipment.no}}
						</el-descriptions-item>
						<el-descriptions-item :label="$t('zhuchanpinbianma')" class="noborder">
							{{$attrs.mouldProduct.materialCode}}
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions :colon="false">
						<el-descriptions-item :label="$t('mujumingcheng')">
							{{$attrs.mouldEquipment.name}}
						</el-descriptions-item>
						<el-descriptions-item :label="$t('zhuchanpinmingcheng')">
							{{$attrs.mouldProduct.name}}
						</el-descriptions-item>
					</el-descriptions>
				</div>

			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/mouldProduct/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<yi_curd_expand_button></yi_curd_expand_button>
		</yi_curd_table>
		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('chanpinbianma/mingcheng')" required="required">
						<yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1"
							:ids.sync="yt.editObj.materialId"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('moqiangshu')" required="required">
						<yi_number_input :type="number" :start.sync="yt.editObj.cavity"></yi_number_input>
					</el-form-item>
          <el-form-item :label="$t('shijimoqiangshu')"
                        required="required"
                        label-width="145px">
            <el-input-number v-model="yt.editObj.actualCavity" controls-position="right" :min="1" :max="maxValue"></el-input-number>
          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/basic/mouldProduct/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('chanpinbianma/mingcheng')" required="required">
						<yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1"
							:ids.sync="yt.editObj.materialId"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('moqiangshu')" required="required">
						<yi_number_input :type="number" :start.sync="yt.editObj.cavity"></yi_number_input>
					</el-form-item>
          <el-form-item :label="$t('shijimoqiangshu')"
                        required="required"
                        label-width="145px">
            <el-input-number v-model="yt.editObj.actualCavity" controls-position="right"  :min="1" :max="maxValue"></el-input-number>
          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/basic/mouldProduct/update',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		/* 唯一命名 */
		name: 'web_base_mould_mould_product',
		data() {
			return {
				columns: [{
					label: 'chanpinbianma',
					prop: 'material.code',
					width: 180,
				}, {
					label: 'chanpinmingcheng',
					prop: 'material.name',
					width: 180,
				}, {
					label: 'moqiangshu',
					prop: 'cavity',
				},{
          label: 'shijimoqiangshu',
          prop: 'actualCavity',
        },  {
					label: 'caozuo',
					type: 'slot',
					width: 120,
					fixed: 'right'
				}]
			};
		},
    computed: {
      maxValue() {
        return this.yt.editObj.cavity
      },

    },
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
					mouldEquipmentId: this.$attrs.mouldProduct.id,
					pageNum: 1,
					pageSize: 10
				}
				this.yt.get(1);
			}, 300)
		},
		methods: {
			setDefaultValue(){
				this.$set(this.yt.editObj, 'cavity', 1)
			},
			beforeAdd(params, url) {
				params.mouldEquipmentId = this.$attrs.mouldProduct.id
				return params
			},

		}
	};
</script>


<style scoped lang="scss">
	.shift {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
	}
</style>
